import moment from 'moment';

export default class GuestlistDuplicationSettingsModalController {
    constructor($uibModalInstance, $scope, $injector, showGuestlistParams, oldGuestlist) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.dismissData = {};
        this.showGuestlistParams = showGuestlistParams;
        this.showStudioSettings = this.injector.get('Users').state.company.settings['lp-api'].studio_used;

        this.acl = $injector.get('Acl');

        this.shouldBePrivate = false;
        this.dataToSend = {
            copy_rsvps: false,
            preserve_codes: false,
            duplicate_studio: this.showStudioSettings,
            duplicate_templates: this.acl.hasModule('templates'),
            duplicate_ticket: this.acl.hasModule('tickets'),
            duplicate_wallet: this.acl.hasModule('passbooks'),
            guestlist_information: {
                name: oldGuestlist ? `${oldGuestlist.name} - Copy` : '',
                settings: {
                    start_date: oldGuestlist ? oldGuestlist.settings.start_date : moment(),
                    end_date: oldGuestlist ? oldGuestlist.settings.end_date : moment()
                },
                permission: 'public'
            }
        };

        this.currentSelectedDuplicationMode = 0;

        this.availableDuplicationModes = [
            {
                label: 'No, settings only',
                values: {
                    copy_rsvps: false,
                    preserve_codes: false
                }
            },
            {
                label: 'Yes, incl. existing booking codes',
                values: {
                    copy_rsvps: true,
                    preserve_codes: true
                }
            },
            {
                label: 'Yes, create new booking codes',
                values: {
                    copy_rsvps: true,
                    preserve_codes: false
                }
            }
        ];
    }

    $onInit() {
        this._initWatchers();
    }

    close() {
        this.modalInstance.close(this.dataToSend);
    }

    dismiss() {
        this.modalInstance.dismiss(this.dismissData);
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.currentSelectedDuplicationMode,
            () => {
                const selectedDuplicationMode = this.availableDuplicationModes[this.currentSelectedDuplicationMode];

                _.each(selectedDuplicationMode.values, (value, key) => {
                    this.dataToSend[key] = value;
                });
            }
        )
        this.scope.$watch(
            () => this.shouldBePrivate,
            () => {
                this.dataToSend.guestlist_information.permission = this.shouldBePrivate ? 'private' : 'public';
            }
        )
    }
}

GuestlistDuplicationSettingsModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'showGuestlistParams',
    'oldGuestlist'
]



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/controllers/modals/guestlist-duplication-settings-modal-controller.js